
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.667 11.417a1 1 0 10-2 0 1 1 0 002 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M12.666 12.417c1.366 0 2.546.85 2.982 2.06l.077.247.016.075a.75.75 0 01-1.443.383l-.023-.073-.038-.124c-.22-.61-.831-1.068-1.57-1.068-.79 0-1.43.52-1.61 1.192a.75.75 0 11-1.448-.385c.356-1.34 1.6-2.307 3.057-2.307zM.25 4.416v-1.75c0-.353.14-.692.39-.942l.098-.089c.237-.194.536-.302.845-.302h3.843l.132.007c.26.026.508.129.712.295l.097.088L8.53 3.887l.052.058a.75.75 0 01-1.056 1.054l-.056-.051-2.115-2.114H1.75v1.583a.75.75 0 01-1.5 0z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M15.75 7.334a.75.75 0 01-1.5 0V5.167H1.75V13h5.707l.077.004a.75.75 0 010 1.492l-.077.004h-5.92a1.29 1.29 0 01-1.28-1.16l-.007-.126V4.417l.004-.077A.75.75 0 011 3.667h13.417c.31 0 .608.107.845.301l.097.09.09.097c.194.237.3.535.301.845v2.334z","fill":"#4A4A4A"}})])
          )
        }
      }
    